import React from 'react';

const QuantumLogo = ({ className = '', size = 'default', showText = true }) => {
  const sizes = {
    small: { icon: 48, text: 'text-sm' },
    default: { icon: 64, text: 'text-xl' },
    large: { icon: 88, text: 'text-3xl' },
  };

  const { icon: iconSize, text: textSize } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Orbital Sphere Icon */}
      <div className="relative" style={{ width: iconSize, height: iconSize }}>
        {/* Glow effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/30 to-purple-500/30 rounded-full blur-lg animate-pulse"></div>
        
        {/* Main sphere */}
        <svg 
          viewBox="0 0 100 100" 
          className="relative w-full h-full"
          fill="none"
        >
          {/* Outer glow */}
          <defs>
            <radialGradient id="sphereGradient" cx="30%" cy="30%">
              <stop offset="0%" stopColor="#22d3ee" stopOpacity="0.8" />
              <stop offset="50%" stopColor="#0891b2" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#1e3a5f" stopOpacity="0.4" />
            </radialGradient>
            <linearGradient id="orbitGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#a855f7" />
              <stop offset="50%" stopColor="#22d3ee" />
              <stop offset="100%" stopColor="#a855f7" />
            </linearGradient>
            <linearGradient id="orbitGradient2" x1="100%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#22d3ee" />
              <stop offset="50%" stopColor="#a855f7" />
              <stop offset="100%" stopColor="#22d3ee" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* Central sphere */}
          <circle 
            cx="50" 
            cy="50" 
            r="22" 
            fill="url(#sphereGradient)"
            filter="url(#glow)"
          />
          
          {/* Grid lines on sphere */}
          <ellipse cx="50" cy="50" rx="22" ry="8" stroke="#22d3ee" strokeWidth="0.5" fill="none" opacity="0.4" />
          <ellipse cx="50" cy="50" rx="8" ry="22" stroke="#22d3ee" strokeWidth="0.5" fill="none" opacity="0.4" />
          
          {/* Orbital ring 1 */}
          <ellipse 
            cx="50" 
            cy="50" 
            rx="40" 
            ry="15" 
            stroke="url(#orbitGradient1)" 
            strokeWidth="2.5"
            fill="none"
            transform="rotate(-20 50 50)"
            filter="url(#glow)"
          />
          
          {/* Orbital ring 2 */}
          <ellipse 
            cx="50" 
            cy="50" 
            rx="35" 
            ry="12" 
            stroke="url(#orbitGradient2)" 
            strokeWidth="2"
            fill="none"
            transform="rotate(40 50 50)"
            filter="url(#glow)"
          />
          
          {/* Light points */}
          <circle cx="30" cy="35" r="3" fill="#22d3ee" opacity="0.8" filter="url(#glow)" />
          <circle cx="70" cy="55" r="2" fill="#a855f7" opacity="0.6" filter="url(#glow)" />
          <circle cx="50" cy="20" r="1.5" fill="#ffffff" opacity="0.5" />
        </svg>
      </div>

      {/* Text */}
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-black tracking-wide ${textSize} bg-gradient-to-r from-cyan-400 via-white to-cyan-400 bg-clip-text text-transparent`}>
            QUANTUM AI
          </span>
          <span className="text-xs font-semibold tracking-[1.1em] text-cyan-500/80 mt-0.5">
            FINTECH
          </span>
        </div>
      )}
    </div>
  );
};

export default QuantumLogo;
